module.exports = __webpack_public_path__ + "img/step_6.5bc00b31.png";